import React, { useEffect, useState } from 'react';
import { X, Phone } from 'lucide-react';

const CTAPopup = ({ isOpen, onClose }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setShow(true);
    }
  }, [isOpen]);

  if (!show) return null;

  const handleClose = () => {
    setShow(false);
    setTimeout(onClose, 300);
  };

  return (
    <>
      {/* Backdrop */}
      <div
        className={`fixed inset-0 bg-black/40 backdrop-blur-md z-50 transition-opacity duration-500 ${
          isOpen ? 'opacity-100' : 'opacity-0'
        }`}
        onClick={handleClose}
      />

      {/* Centered Popup */}
      <div
        className={`fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50 transition-all duration-500 ${
          isOpen ? 'scale-100 opacity-100' : 'scale-90 opacity-0'
        }`}
      >
        <div className="bg-white rounded-lg shadow-2xl max-w-md w-full mx-4 relative overflow-hidden">
          {/* Decorative top border */}
          <div className="h-2 bg-gradient-to-r from-sage-500 via-pink-400 to-sage-500"></div>
          
          {/* Close Button */}
          <button
            onClick={handleClose}
            className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors duration-200 z-10"
          >
            <X size={24} />
          </button>

          {/* Content */}
          <div className="p-8">
            <div className="flex flex-col items-center text-center space-y-6">
              {/* Icon */}
              <div className="w-20 h-20 bg-gradient-to-br from-sage-500 to-sage-700 rounded-full flex items-center justify-center shadow-lg animate-pulse-slow">
                <Phone className="w-10 h-10 text-white" />
              </div>

              {/* Heading */}
              <div>
                <h3 className="text-2xl md:text-3xl font-light text-gray-900 mb-3 tracking-tight">
                  Ready to Transform Your Hair?
                </h3>
                <p className="text-base text-gray-600 font-light leading-relaxed">
                  Text us now to book your exclusive 1-on-1 appointment with our expert stylists.
                </p>
              </div>

              {/* CTA Button */}
              <a
                href="sms:0475409162"
                className="w-full bg-sage-600 text-white px-8 py-4 rounded-sm hover:bg-sage-700 hover:shadow-lg hover:shadow-pink-300 transition-all duration-300 font-normal tracking-wide text-center shadow-lg block"
              >
                Text Us: <span className="whitespace-nowrap">0475 409 162</span>
              </a>

              {/* Note */}
              <p className="text-xs text-gray-500 font-light">
                Text only - we can't answer calls while with clients
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CTAPopup;
